import { Routes } from '@angular/router';

export const USER_ROUTES: Routes = [
    {
    path: '',
    loadComponent: () =>
      import('./user.component').then(m => m.UserComponent),
    title: 'User Panel',
    children: [
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent),
    title: 'Dashboard'
  },
  {
    path: 'instance',
    loadComponent: () => import('./instances/instances.component').then(m => m.InstancesComponent),
    title: 'Instances'
  },
  {
    path: 'api-docs',
    loadComponent: () => import('./api-docs/api-docs.component').then(m => m.ApiDocsComponent),
    title: 'API Documentation'
  },
  {
    path: 'base64',
    loadComponent: () => import('./file-to-base64/file-to-base64.component').then(m => m.FileToBase64Component),
    title: 'File to Base64'
  },
  {
    path: 'vcard-generator',
    loadComponent: () => import('./vcard/vcard.component').then(m => m.VCardComponent),
    title: 'vCard Generator'
  },
  {
    path: 'instance/products',
    loadComponent: () => import('./products/products.component').then(m => m.ProductsComponent),
    title: 'Products'
  },
  {
    path: 'instance/channels/scan',
    loadComponent: () => import('./add-account/add-account.component').then(m => m.AddAccountComponent),
    title: 'Scan Channel'
  },
  {
    path: 'instance/channels/account',
    loadComponent: () => import('./account-profile/account-profile.component').then(m => m.AccountProfileComponent),
    title: 'Account Profile'
  },
  {
    path: 'profile',
    loadComponent: () => import('./profile/profile.component').then(m => m.ProfileComponent),
    title: 'User Profile'
  },
  {
    path: 'account',
    loadComponent: () => import('./whats-app-accounts/whats-app-accounts.component').then(m => m.WhatsAppAccountsComponent),
    title: 'WhatsApp Accounts'
  },
  {
    path: 'addProduct',
    loadComponent: () => import('./add-product/add-product.component').then(m => m.AddProductComponent),
    title: 'Add Product'
  },
  {
    path: 'addProduct/:id',
    loadComponent: () => import('./add-product/add-product.component').then(m => m.AddProductComponent),
    title: 'Edit Product'
  },
  {
    path: 'product_details',
    loadComponent: () => import('./add-product/add-product-details/add-product-details.component').then(m => m.AddProductDetailsComponent),
    title: 'Product Details'
  },
  {
    path: 'instance/knowledge/base',
    loadComponent: () => import('./add-product/knowledge-base/knowledge-base.component').then(m => m.KnowledgeBaseComponent),
    title: 'Knowledge Base'
  },
  {
    path: 'instance/knowledge/list',
    loadComponent: () => import('./add-product/knowledge-list/knowledge-list.component').then(m => m.KnowledgeListComponent),
    title: 'Knowledge List'
  },
  {
    path: 'verify_details',
    loadComponent: () => import('./add-product/verify-product-details/verify-product-details.component').then(m => m.VerifyProductDetailsComponent),
    title: 'Verify Details'
  },
  {
    path: 'qdrant/:id',
    loadComponent: () => import('./add-product/simple-qdrant-edit/simple-qdrant-edit.component').then(m => m.SimpleQdrantEditComponent),
    title: 'Qdrant Edit'
  },
  {
    path: 'verify_details/:id',
    loadComponent: () => import('./add-product/verify-product-details/verify-product-details.component').then(m => m.VerifyProductDetailsComponent),
    title: 'Verify Details'
  },
  {
    path: 'model_preference',
    loadComponent: () => import('./add-product/model-preference/model-preference.component').then(m => m.ModelPreferenceComponent),
    title: 'Model Preference'
  },
  {
    path: 'instance/model_preference/:id',
    loadComponent: () => import('./add-product/model-preference/model-preference.component').then(m => m.ModelPreferenceComponent),
    title: 'Model Preference'
  },
  {
    path: 'instance/chat_summary',
    loadComponent: () => import('./chat-summary/chat-summary.component').then(m => m.ChatSummaryComponent),
    title: 'Chat Summary'
  },
  {
    path: 'instance/edit_chat_summary/:id',
    loadComponent: () => import('./chat-summary/edit-chat-summary/edit-chat-summary.component').then(m => m.EditChatSummaryComponent),
    title: 'Edit Chat Summary'
  },
  {
    path: 'multicalendar',
    loadComponent: () => import('../shared/date-picker/date-picker.component').then(m => m.DatePickerComponent),
    title: 'Multi Calendar'
  },
  {
    path: 'instance/report',
    loadComponent: () => import('./report/report.component').then(m => m.ReportComponent),
    title: 'Report'
  },
  {
    path: 'instance/exclude',
    loadComponent: () => import('../component/exclude-number/exclude-number.component').then(m => m.ExcludeNumberComponent),
    title: 'Exclude Number'
  },
  {
    path: 'instance/include',
    loadComponent: () => import('../component/include-number/include-number.component').then(m => m.IncludeNumberComponent),
    title: 'Include Number'
  },
  {
    path: 'instance/campaign/track',
    loadComponent: () => import('./campaign/campaign.component').then(m => m.CampaignComponent),
    title: 'Campaign Tracking'
  },
  {
    path: 'instance/customer',
    loadComponent: () => import('./client-contacts/client-contacts.component').then(m => m.ClientContactsComponent),
    title: 'Customers'
  },
  {
    path: 'instance/customer/create',
    loadComponent: () => import('./client-contacts/create-customer/create-customer.component').then(m => m.CreateCustomerComponent),
    title: 'Create Customer'
  },
  {
    path: 'instance/customer/create/:id',
    loadComponent: () => import('./client-contacts/create-customer/create-customer.component').then(m => m.CreateCustomerComponent),
    title: 'Edit Customer'
  },
  {
    path: 'instance/calendar',
    loadComponent: () => import('../shared/date-picker/date-picker.component').then(m => m.DatePickerComponent),
    title: 'Calendar'
  },
  {
    path: 'instance/calendar-integration',
    loadComponent: () => import('../shared/calendar-integration/calendar-integration.component').then(m => m.CalendarIntegrationComponent),
    title: 'Calendar Integration'
  },
  {
    path: 'add/manager',
    loadComponent: () => import('../pages/add-manager/add-manager.component').then(m => m.AddManagerComponent),
    title: 'Add Manager'
  },
  {
    path: 'instance/kanban',
    loadComponent: () => import('../component/kanban-view/kanban-view.component').then(m => m.KanbanViewComponent),
    title: 'Kanban View'
  },
  {
    path: 'add-client',
    loadComponent: () => import('../component/add-client/add-client.component').then(m => m.AddClientComponent),
    title: 'Add Client'
  },
  {
    path: 'add-client/:id',
    loadComponent: () => import('../component/add-client/add-client.component').then(m => m.AddClientComponent),
    title: 'Edit Client'
  },
  {
    path: 'instance/add-client/:id',
    loadComponent: () => import('../component/add-client/add-client.component').then(m => m.AddClientComponent),
    title: 'Edit Client'
  },
  {
    path: 'instance/assignment-rule',
    loadComponent: () => import('../component/assignment-rule/assignment-rule.component').then(m => m.AssignmentRuleComponent),
    title: 'Assignment Rule'
  },
  {
    path: 'instance/instagram-connect',
    loadComponent: () => import('../instagram/connect-instagram/connect-instagram.component').then(m => m.ConnectInstagramComponent),
    title: 'Instagram Connect'
  },
  {
    path: 'instance/connect-list',
    loadComponent: () => import('../instagram/all-connect-automations/all-connect-automations.component').then(m => m.AllConnectAutomationsComponent),
    title: 'Connect Automations'
  },
  {
    path: 'instance/posts',
    loadComponent: () => import('../instagram/instagram-posts/instagram-posts.component').then(m => m.InstagramPostsComponent),
    title: 'Instagram Posts'
  },
  {
    path: 'instance/conversion',
    loadComponent: () => import('./conversion/conversion.component').then(m => m.ConversionComponent),
    title: 'Conversion'
  },
  {
    path: 'settings/smtp',
    loadComponent: () => import('../setting/org-smtp/org-smtp.component').then(m => m.OrgSmtpComponent),
    title: 'SMTP Settings'
  },
  {
    path: 'settings/encryption',
    loadComponent: () => import('../setting/encryption/encryption.component').then(m => m.EncryptionComponent),
    title: 'Encryption Settings'
  },
  {
    path: 'settings/organizations/edit/:id',
    loadComponent: () => import('../admin/organizations/create-organization/create-organization.component').then(m => m.CreateOrganizationComponent),
    title: 'Edit Organization'
  },
  // {
  //   path: 'settings/addons',
  //   loadComponent: () => import('../setting/addons/addons.component').then(m => m.AddonsComponent),
  //   title: 'addons'
  // },
  {
    path: 'instance/platform/settings',
    loadComponent: () => import('../setting/whatsapp-settings/whatsapp-settings.component').then(m => m.WhatsappSettingsComponent),
    title: 'WhatsApp Settings'
  },
  {
    path: 'settings/developer-tools',
    loadComponent: () => import('../component/developer-tools/developer-tools.component').then(m => m.DeveloperToolsComponent),
    title: 'Developer Tools'
  },
  {
    path: 'instance/templates-list',
    loadComponent: () => import('../component/templates/templates-list/templates-list.component').then(m => m.TemplatesListComponent),
    title: 'Templates List'
  },
  {
    path: 'instance/templates/create',
    loadComponent: () => import('../component/templates/template-create/template-create.component').then(m => m.TemplateCreateComponent),
    title: 'Create Template'
  },
    {
    path: 'instance/templates/edit/:id',
    loadComponent: () => import('../component/templates/template-create/template-create.component').then(m => m.TemplateCreateComponent),
    title: 'Edit Template'
  },
  {
    path: 'instance/platform/contacts',
    loadComponent: () => import('../component/contacts/whatsapp-contacts/whatsapp-contacts.component').then(m => m.WhatsappContactsComponent),
    title: 'WhatsApp Contacts'
  },
  {
    path: 'instance/campaigns',
    loadComponent: () => import('../pages/whatsapp-campaigns/whatsapp-campaign-list/whatsapp-campaign-list.component').then(m => m.WhatsappCampaignListComponent),
    title: 'Campaigns'
  },
  {
    path: 'instance/campaigns/create',
    loadComponent: () => import('../pages/whatsapp-campaigns/whatsapp-campaign-create/whatsapp-campaign-create.component').then(m => m.WhatsappCampaignCreateComponent),
    title: 'Create Campaign'
  },
  {
    path: 'instance/subscription',
    loadComponent: () => import('../setting/whatsapp-settings/subscription-plan/subscription-plan.component').then(m => m.SubscriptionPlanComponent),
    title: 'Subscription'
  },
  {
    path: 'instance/lead-manager',
    loadComponent: () => import('./lead-manager/lead-manager.component').then(m => m.LeadManagerComponent),
    title: 'Lead Manager'
  },
  {
    path: 'instance/chats',
    loadComponent: () => import('./chat-layout/chat-layout.component').then(m => m.ChatLayoutComponent),
    title: 'Chats',
    children: [
      {
        path: ':id',
        loadComponent: () => import('./chat-detail/chat-detail.component').then(m => m.ChatDetailComponent),
        title: 'Chat Detail'
      }
    ]
  },
  {
    path: 'instance/instagram-chats',
    loadComponent: () => import('./instagram-chats/instagram-chat-layout/instagram-chat-layout.component').then(m => m.InstagramChatLayoutComponent),
    title: 'Instagram Chats',
    children: [
      {
        path: ':id',
        loadComponent: () => import('./instagram-chats/instagram-chat-detail/instagram-chat-detail.component').then(m => m.InstagramChatDetailComponent),
        title: 'Instagram Chat Detail'
      }
    ]
  },
      // {
      //   path: 'projects',
      //   loadChildren: () =>
      //     import('../pages/project-list/projects.routes')
      //       .then(m => m.PROJECT_ROUTES),
      // },
      {
        path: 'instance/advanced-features',
        loadComponent: () => import('../setting/client-feature-config/client-feature-config.component').then(m => m.ClientFeatureConfigComponent),
        title: 'Advanced Features'
      },
      {
        path: 'instance/nurturing-flows',
        loadComponent: () => import('./nurturing-flows/nurturing-flows-list/nurturing-flows-list.component').then(m => m.NurturingFlowsListComponent),
        title: 'Nurturing Flows'
      },
      {
        path: 'instance/nurturing-flows/create',
        loadComponent: () => import('./nurturing-flows/nurturing-flow-builder/nurturing-flow-builder.component').then(m => m.NurturingFlowBuilderComponent),
        title: 'Create Nurturing Flow'
      },
      {
        path: 'instance/retargeting',
        loadComponent: () => import('./retargeting/retargeting.component').then(m => m.RetargetingComponent),
        title: 'Retargeting Tool'
      },
    ],
  },
];
